function Unauthorized(){

    return(
        <div>
            <h2>
                You Aren't Authorized To Be Here, Go Away!
            </h2>
        </div>
    );
}
export default Unauthorized;